import { Box, Stack } from '@mui/material'
import { node } from 'prop-types'
import React from 'react'

import useIsBelowBreakpoint from 'hooks/useIsBelowBreakpoint'

import useStyles from './styles'

const Footer = ({ logo }) => {
  const classes = useStyles()
  const isBelowMd = useIsBelowBreakpoint('md')

  return (
    <footer className={classes.footer}>
      <Stack
        justifyContent="center"
        alignItems="center"
        flexDirection={isBelowMd ? 'column' : 'row'}
        gap={2}
      >
        <Box>
          <img src={logo} alt={logo} className={classes.logo} />
        </Box>
        <Box className={classes.legal}>
          Informations indicatives, seuls les rapports délivrés par les
          techniciens habilités à les réaliser font référence
          <br />
          &copy; 2022 DIGILIANCE Digitalisation du patrimoine immobilier. Tous
          droits réservés.
        </Box>
      </Stack>
    </footer>
  )
}

Footer.propTypes = {
  logo: node.isRequired,
}

export default Footer
